import { getField, updateField } from "vuex-map-fields";
import productsService from "@/services/products";
import notification from "@/services/notification";

export default {
  namespaced: true,
  state: {
    basic_details: {
      name: null,
      description: null,
      branch_uuids: [],
      selected_all_brands_branches: false,
      visibility: true,
      regular_price: null,
      currency: "PHP",
      sku: null,
      product_link: null
    },
    product_images: [],
    category_id: null,
    product_inventory: {
      stock: 1,
      is_limited_stock: false
    },
    product_on_sale: {
      on_sale: false,
      discount_value: null,
      discount_type: "%",
      on_sale_from: "YYYY-MM-DD HH:MM:SS",
      on_sale_to: "YYYY-MM-DD HH:MM:SS",
      date_range: null
    },
    product_attributes: [],
    product_variables: [],
    add_ons: [],
    is_saved: false,
    errors: null,
    isLoading: false,
    inventoryList: [],
    filters: {},
    pagination: {},
    isAllSelected: false,
    selectedItems: [],
    product_delete: null,
    inventoryListParameters: null,
    sales_channel: {
      is_available_on_estore: false,
      is_available_on_dine_in: false
    },
    enable_special_discount: false
  },
  getters: {
    getField
  },
  mutations: {
    updateField,
    pushProductImage(state, base64) {
      state.product_images.push({ ...base64, index: state.product_images.length });
    },
    removeImage(state, { action, index }) {
      if (action === "delete")
        state.product_images[index].action = action;
      else
        state.product_images.splice(imageIndex, 1);
    },
    setErrors(state, errors) {
      state.errors = errors;
    },
    setIsLoading(state, value) {
      state.isLoading = value;
    },
    setInventoryList(state, value) {
      state.inventoryList = value;
    },
    setPagination(state, value) {
      state.pagination = value;
    },
    pushProductAttributes(state, attributes) {
      state.product_attributes.push(attributes);
    },
    setProductAttributes(state, attributes) {
      state.product_attributes = attributes;
    },
    setProductVariables(state, variables) {
      state.product_variables = variables;
    },
    setProductDeleteInventory(state, data) {
      state.product_delete = data;
    },
    deleteProductInventory(state, index) {
      state.product_variables.splice(index, 1);
    },
    pushAddOns(state, addon) {
      state.add_ons.push(addon);
    },
    setAddOns(state, { data, data_index }) {
      state.add_ons[data_index] = { ...data };
    },
    deleteAddOn(state, data_index) {
      state.add_ons.splice(data_index, 1);
    },
    resetForm(state) {
      state.basic_details = {
        name: null,
        description: null,
        branch_uuids: [],
        selected_all_brands_branches: false,
        visibility: true,
        regular_price: null,
        currency: "PHP",
        sku: null,
        product_link: null
      };
      state.product_images = [];
      state.category_id = null;
      state.product_inventory = {
        stock: null,
        is_limited_stock: false
      };
      state.product_on_sale = {
        on_sale: false,
        discount_value: null,
        discount_type: "%",
        on_sale_from: "YYYY-MM-DD HH:MM:SS",
        on_sale_to: "YYYY-MM-DD HH:MM:SS",
        date_range: null
      };
      state.product_attributes = [];
      state.product_variables = [];
      state.add_ons = [];
      state.enable_special_discount = false
    },
    setFilters(state, value) {
      state.filters = value;
    },
    setProductData(state, { data, type }) {
      state[type] = data;
    },
    setInventoryListParameters(state, value) {
      state.inventoryListParameters = value;
    },
  },
  actions: {
    async getInventoryList({ commit }, parameters) {
      commit("setInventoryList", []);
      commit("setIsLoading", true);

      try {
        const response = await productsService.getInventoryList(parameters);

        commit("setInventoryListParameters", parameters);
        commit("setInventoryList", response.data);
        commit("setPagination", {
          currentPage: parameters.page,
          previousPage: response.prev_page,
          maxPage: response.max_page,
        })
      } catch (errors) {
        commit("setErrors", errors);
      } finally {
        commit("setIsLoading", false);
      }
    },
    async getProductInventoryList({ commit }, parameters) {
      commit("setInventoryList", []);
      commit("setIsLoading", true);

      try {
        const response = await productsService.getProductInventoryList(parameters);

        commit("setInventoryList", [response.data]);
        commit("setPagination", {
          currentPage: parameters.page,
          previousPage: response.prev_page,
          maxPage: response.max_page,
        })
      } catch (errors) {
        commit("setErrors", errors);
      } finally {
        commit("setIsLoading", false);
      }
    },
    async updateInventory({ commit }, payload) {
      commit("setIsLoading", true);
      commit("setErrors", null);

      try {
        const { message } = await productsService.updateInventory(payload);
        notification.success(message);
      } catch (errors) {
        notification.warning("Oops, cannot update product inventory.");
        commit("setErrors", errors);
      } finally {
        commit("setIsLoading", false);
      }
    },

    async updateAddOns({ commit }, payload) {
      commit("setIsLoading", true);
      commit("setErrors", null);

      try {
        const { message } = await productsService.updateAddOns(payload);
        notification.success(message)
      } catch (errors) {
        commit("setErrors", errors.errors);
      } finally {
        commit("setIsLoading", false);
      }
    }
  }
};
